import { render, staticRenderFns } from "./dlgLog.vue?vue&type=template&id=85623d04"
import script from "./dlgLog.vue?vue&type=script&lang=js"
export * from "./dlgLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports